import React from 'react';
import PropTypes from 'prop-types';
import OutOfOffice from '@fiverr-private/out_of_office/src/OutOfOffice';
import { MODAL_WRAPPER_CLASS } from '../constants';

import './style.scss';

const SellerOutOfOffice = (props) => {
    const { username, isPageOwner, vacationMessage, vacationEndDate, isOnVacation, profilePhoto, reason } = props;

    const outOfOfficeProps = {
        is_page_owner: isPageOwner,
        profile_image_url: profilePhoto,
        username,
        end_date: vacationEndDate && Date.parse(vacationEndDate) / 1000,
        reason,
        message_for_buyer: vacationMessage,
        is_on_vacation: isOnVacation,
        modalCustomName: MODAL_WRAPPER_CLASS
    };

    return (
        <OutOfOffice {...outOfOfficeProps}/>
    );
};

SellerOutOfOffice.propTypes = {
    username: PropTypes.string.isRequired,
    vacationEndDate: PropTypes.string.isRequired,
    profilePhoto: PropTypes.string.isRequired,
    isPageOwner: PropTypes.bool,
    isOnVacation: PropTypes.bool,
    vacationMessage: PropTypes.string
};

export default SellerOutOfOffice;
